import Mapbox from './mapbox';

export default class MapboxDesktop extends Mapbox {
    constructor(...args) {
        super(...args);
    }
}



// WEBPACK FOOTER //
// src/js/components/mapbox/mapbox.desktop.js